import './DatePicker.css';const e = "DatePicker-module__launcher___c8ngk", _ = "DatePicker-module__floating___5VjjX", o = "DatePicker-module__open___z-NoT", t = "DatePicker-module__date___LSvPs", n = {
  launcher: e,
  floating: _,
  open: o,
  date: t
};
export {
  n as s
};
